<template>
  <div class="packaging-management">
    <!-- 顶部信息和操作区 -->
    <div class="top-container">
      <!-- 左侧单号信息区 -->
      <div class="left-info">
        <div class="info-item">
          <label class="info-label">转发承运商</label>
          <vxe-input class="info-input"/>
        </div>
        <div class="info-item">
          <label class="info-label">原快递号</label>
          <vxe-input class="info-input"/>
          <a-checkbox checked class="lock-checkbox">直接转发</a-checkbox>
        </div>
        <div class="info-item">
          <label class="info-label">转发指定快递单号</label>
          <vxe-input class="info-input"/>
          <a-checkbox checked class="lock-checkbox">扫描</a-checkbox>
        </div>
      </div>

      <!-- 中间订单信息区 -->
      <div class="middle-info">
        <div class="info-text">订单号</div>
        <div class="info-text">原承运商</div>
        <div class="info-text">转发快递单</div>
        <div class="info-text">转发结果</div>

      </div>

      <!-- 右侧操作按钮区 -->
      <div class="right-actions">
        <a-button type="primary" class="action-btn">确认</a-button>
        <a-button type="primary" class="action-btn">补打</a-button>
        <a-checkbox class="packaging-scan">打印快递单</a-checkbox>
        <a-button type="primary" class="action-btn">手动填充</a-button>
      </div>
    </div>

    <!-- 底部表格区域 -->
    <div class="table-container">
      <!-- 待扫描表格 -->
      <div class="left-table">
        <div class="table-header">包裹明细</div>
        <a-table
          :columns="pendingColumns"
          :data-source="pendingData"
          bordered
          :pagination="false"
        >
          <template slot="emptyText">
            <div class="empty-table-placeholder"></div>
          </template>
        </a-table>
      </div>

      <!-- 切换按钮 -->
      <div class="switch-btn">
        <a-button shape="circle" size="small">
          <a-icon type="swap-right" />
        </a-button>
      </div>

      <!-- 已扫描标签页表格 -->
      <div class="right-table">
        <a-tabs defaultActiveKey="1">
          <a-tab-pane key="1" tab="转发信息"></a-tab-pane>
        </a-tabs>
        <a-table
          :columns="scannedColumns"
          :data-source="scannedData"
          bordered
          :pagination="false"
        >
          <template slot="emptyText">
            <div class="empty-table-placeholder"></div>
          </template>
        </a-table>
      </div>
    </div>

    <!-- 右侧统计数据 -->
    <div class="statistics-panel">
      <div class="stat-item">
        <div class="stat-label">今日转发量</div>
        <div class="stat-value blue">0</div>
      </div>
      <div class="user-avatar">
        <a-avatar icon="user" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 待扫描表格列定义
      pendingColumns: [
        {
          title: '',
          dataIndex: 'check',
          width: 30,
          render: () => <a-checkbox />
        },
        {
          title: '商品编码',
          dataIndex: 'productBarcode',
          width: 120
        },
        {
          title: '条码类型',
          dataIndex: 'barcode',
          width: 100
        },
        {
          title: '包裹号',
          dataIndex: 'codeType',
          width: 80
        },
        {
          title: '承运商',
          dataIndex: 'productBarcode',
          width: 120
        },
        {
          title: '数量',
          dataIndex: 'product',
          width: 150
        }
      ],
      // 待扫描表格数据
      pendingData: [
        { key: '1' },
        { key: '2' },
        { key: '3' },
        { key: '4' },
        { key: '5' }
      ],
      // 已扫描表格列定义
      scannedColumns: [
        {
          title: '',
          dataIndex: 'check',
          width: 30,
          render: () => <a-checkbox />
        },
        {
          title: '单号',
          dataIndex: 'packageNo',
          width: 100
        },
        {
          title: '原快递号',
          dataIndex: 'packagingCode',
          width: 100
        },
        {
          title: '包原承运商',
          dataIndex: 'packagingName',
          width: 150
        },
        {
          title: '转发快递单号',
          dataIndex: 'scanned',
          width: 80
        },
        {
          title: '转发承运商',
          dataIndex: 'scanned',
          width: 80
        }
      ],
      // 已扫描表格数据
      scannedData: [
        { key: '1' },
        { key: '2' },
        { key: '3' },
        { key: '4' },
        { key: '5' }
      ]
    };
  }
};
</script>

<style scoped>
.packaging-management {
  position: relative;
  padding: 16px;
  padding-right: 120px;
  background-color: #fff;
  min-height: 100vh;
}

/* 顶部信息区域样式 */
.top-container {
  display: flex;
  margin-bottom: 16px;
  gap: 24px;
}

.left-info {
  display: flex;
  flex-direction: column;
  gap: 60px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-label {
  width: 80px;
  text-align: right;
  font-size: 14px;
  color: #333;
}

.info-input {
  width: 200px;
}

.lock-checkbox {
  margin-left: 8px;
}

.scan-checkbox {
  margin-left: 8px;
}

.middle-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.info-text {
  height: 32px;
  line-height: 32px;
  font-size: 25px;
  color: #666;
}

.right-actions {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.action-btn {
  width: 140px;
  height: 36px;
  font-size: 14px;
}

.packaging-scan {
  margin-top: 4px;
  padding: 6px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

/* 表格区域样式 */
.table-container {
  display: flex;
  gap: 12px;
}

.left-table, .right-table {
  flex: 1;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}

.table-header {
  padding: 8px 16px;
  border-bottom: 1px solid #e8e8e8;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.switch-btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-table-placeholder {
  height: 200px;
  background-color: #fafafa;
}

/* 右侧统计面板样式 */
.statistics-panel {
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
  height: 100%;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  gap: 30px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
}

.blue {
  color: #1890ff;
}

.green {
  color: #52c41a;
}

.red {
  color: #f5222d;
}

.black {
  color: #000;
}

.user-avatar {
  margin-top: auto;
  margin-bottom: 20px;
}
</style>
